module.exports = "/_next/static/images/four_service-e1211eda1a9047c39d376f891fc4fc9e.jpg";